import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { IInvoice, Invoice } from "@/models/invoice.entity";
import { MrfiktivInvoiceControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { getModule, Module } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { InvoiceDataAccessLayer } from "./access-layers/invoice.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { InvoicePageDataProvider } from "./page-data-provider/invoice.page-data-provider";

@Module({
  dynamic: true,
  namespaced: true,
  name: "invoice",
  store
})
export class InvoiceStore extends PaginatedBaseStore<IInvoice, MrfiktivInvoiceControllerGetParamsGen> {
  protected _data = InvoiceDataAccessLayer;
  protected _pageProvider = InvoicePageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = Invoice.filterables;
}

export const InvoiceModule = getModule(InvoiceStore);
